<template>
	<div class="footer">
		<div class="footer-header">
			<!-- <div class="footer-logo">
				<el-image style="width: 40px;height: 30px" :src="require('@/../static/basic/footer/icon.png')"  fit="contain" />
				<el-image style="width: 70px;height: 30px" :src="require('@/../static/basic/footer/title.png')" fit="contain" />
			</div> -->
			
			<div class="footer-section">
				<div class="footer-title">
					功能模块
				</div>
				<div class="footer-item" @click="$navto('/my/searchInsure')">
					保单查询
				</div>
				<div class="footer-item" @click="$navto('/insure/insureGuide')">
					投保指引
				</div>
				<div class="footer-item" @click="$navto('/insure/claimsGuide')">
					理赔指南
				</div>
			</div>
			
			<div class="footer-section">
				<div class="footer-title">
					联系邮箱
				</div>
				<div class="footer-item">
					{{ $getter('setting').value2 }}
				</div>
			</div>
			
			<div class="footer-section">
				<div class="footer-title">
					联系电话
				</div>
				<div class="footer-item">
					{{ $getter('setting').value1 }}
				</div>
			</div>
			
			<div class="footer-section">
				<div class="footer-title">
					工作时间
				</div>
				<div class="footer-item">
					{{ $getter('setting').value4 }}
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			{{ $getter('setting').value3 }}
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mainFooter',
		data() {
			return {
				
			};
		},
		mounted() {
			
		},
		methods: {
			
		}
	};
</script>
<style lang="scss" scoped>
	.footer {
		background-color: #222222;
		position: relative;
		bottom: 0;
		left: 0;
		right: 0;
		height: 300px;
		.footer-header {
			padding: 40px 16% 30px;
			display: flex;
			justify-content: space-between;
			align-items: top;
			border-bottom: 1px solid #333333;
			.footer-logo {
				display: flex;
				justify-content: flex-start;
				gap: 10px;
				width: 200px;
			}
			
			.footer-section {
				.footer-title {
					color: #FFFFFF;
					font-size: 18px;
				}
				.footer-item {
					margin-top: 10px;
					color: #999999;
					font-size: 14px;
					cursor: pointer;
				}
			}
		}
		.footer-bottom {
			text-align: center;
			color: #999999;
			font-size: 14px;
			margin-top: 30px;
		}
	}
</style>